<div class="header-row">
  <div class="header">Izveštaji</div>
</div>

<div class="table-container">
  <div class="mat-elevation-z2">
    <table
      mat-table
      [dataSource]="reports"
      matSort
      (matSortChange)="sortData($event)"
    >
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Ime</th>
        <td mat-cell *matCellDef="let report">{{ report.label }}</td>
      </ng-container>

      <ng-container matColumnDef="creationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="creationDate">
          Datum izrade
        </th>
        <td mat-cell *matCellDef="let report">
          {{ report.creationDate | date }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updateDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="updateDate">
          Datum izmene
        </th>
        <td mat-cell *matCellDef="let report">
          {{ report.updateDate | date }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let report">
          <button
            (click)="openReportDetails(report)"
            mat-button
            mat-stroked-button
            color="primary"
            [ngStyle]="{
              padding: '0 16px',
              borderRadius: '8px',
              fontSize: '14px',
              letterSpacing: '0.8px',
              fontWeight: 'bold'
            }"
          >
            <mat-icon
              aria-hidden="false"
              aria-label=" logout icon"
              fontIcon="insert_drive_file"
            ></mat-icon>
            Izveštaj
          </button>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="header-row-color"
      ></tr>
      <tr
        mat-row
        class="reports-table-row"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>
</div>
